import api from "../api/axiosConfig";

const salesService = {
  getAvailable: () => api.get("/sales/available"),
  create: (items) => api.post("/sales", { items }),
  dailyReport: (date) => api.post("/sales/dailyReport", { date }),
};

export default salesService;
